
import { userToolStore } from '@/store';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class CaixaAbrirComponent extends Vue {
  @Prop({ type: Number }) public propEntidadeId;
  @Prop({ type: String }) public propEntidadeNome;
  @Prop({ type: String }) public propEntidadeTipo;
  @Prop({ type: Boolean, default: true }) public small;
  @Prop({ type: Boolean, default: false }) public transparent;

  get getUserToolsVisualizar() {
    let habilitarLink = false;
    if (userToolStore.userToolsIndexed.unidades) {
      if (userToolStore.userToolsIndexed.unidades[0].allow_view) {
        habilitarLink = true;
      }
    }
    return habilitarLink;
  }

  public async abrirCadastro() {
    let entidade_tipo = 'unidade-info';
    const rota = this.$router.resolve({
      name: entidade_tipo,
      params: { id: this.propEntidadeId },
    });
    window.open(rota.href, '_blank');
  }
}
